import React from 'react'
import { Video, AlertCircle, MapPin, Monitor } from 'react-feather'

import { ConsultationType } from '@/core/graphql/types'

import { getConsultationTypeLabel } from '../lib/consultationStatus'

const typeConfig: Record<string, { icon: React.ReactNode; bgColor: string; textColor: string }> = {
  [ConsultationType.Classic]: { icon: <Video size={12} />, bgColor: 'bg-indigo-50', textColor: 'text-indigo-600' },
  [ConsultationType.Emergency]: { icon: <AlertCircle size={12} />, bgColor: 'bg-red-50', textColor: 'text-red-600' },
  [ConsultationType.Local]: { icon: <MapPin size={12} />, bgColor: 'bg-teal-50', textColor: 'text-teal-600' },
  [ConsultationType.MeetingOnly]: { icon: <Monitor size={12} />, bgColor: 'bg-blue-50', textColor: 'text-blue-600' },
}

export function ConsultationTypeBadge({ type }: { type: ConsultationType }) {
  const config = typeConfig[type]
  if (!config) return null

  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold ${config.bgColor} ${config.textColor}`}>
      {config.icon}
      <span>{getConsultationTypeLabel(type)}</span>
    </span>
  )
}
